
import s from './Footer'
export default s
